import announcementTypes from 'dashboard/actions/announcements/announcement-types';

import template from './announcement-item.html';

class AnnouncementItemController {
  constructor() {
    this.announcementTypes = announcementTypes;
  }
}

export default class AnnouncementItemComponent {
  constructor() {
    this.controller = AnnouncementItemController;
    this.template = template;
    this.bindings = {
      language: '<',
      announcement: '<',
      index: '<',
      type: '<',
      pin: '&?',
      edit: '&?',
      delete: '&?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-item/announcement-item-component.js